import * as React from 'react';
import Backdrop from '@mui/material/Backdrop';
import Box from '@mui/material/Box';
import Modal from '@mui/material/Modal';
import Fade from '@mui/material/Fade';
import Typography from '@mui/material/Typography';
import './modal.scss'

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 800,
  bgcolor: 'background.paper',
  border: '4px solid #7451f8',
  boxShadow: 24,
  p: 4,
};

const titleStyle ={
  color: '#7451f8'
}

const TransitionModal = ({modalOpen,handleClose,title,body}) => {

  return (
    <div>
      <Modal
        aria-labelledby="transition-modal-title"
        aria-describedby="transition-modal-description"
        open={modalOpen}
        onClose={handleClose}
        closeAfterTransition
        slots={{ backdrop: Backdrop }}
        slotProps={{
          backdrop: {
            timeout: 500,
          },
        }}
      >
        <Fade in={modalOpen}>
          <Box sx={style}>
            <Typography id="transition-modal-title" variant="h6" component="h2" sx={titleStyle}>
              {title ? title : "Modal Title"}
            </Typography>
            <hr/>
            <Typography id="transition-modal-description" sx={{ mt: 2 }}>
              {body ? body : "Modal Body"}
            </Typography>
          </Box>
        </Fade>
      </Modal>
    </div>
  );
}

export default TransitionModal;